import React from 'react';
import { Dialog, DialogTitle, IconButton, Typography, DialogActions, Button, Divider, DialogContent, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useIsMobile } from '../../../../../components/Mui3WidthProvider';
import { PremiumSermonAsset } from '../../../../../entities/PremiumSermonAsset';
import { PremiumSermonSeriesAsset } from '../../../../../entities/PremiumSermonSeriesAsset';
import { useAuthenticatedUser } from '../../../../../utilities/useAuthenticatedUser';

const useStyles = makeStyles((theme) => ({
    previewCloseIcon: {
        float: 'right',
    },
    userTemplateButton: {
        marginTop: 5,
        marginBottom: 0,
        marginLeft: 'auto',
        display: 'flex',
        marginRight: 'auto'
    },
    previewText: {
        '-webkit-user-select': 'none',
        '-khtml-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        '-o-user-select': 'none',
        userSelect: 'none'
    },
    previewTextPremiumBlurred: {
        '-webkit-user-select': 'none',
        '-khtml-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        '-o-user-select': 'none',
        userSelect: 'none',
        display: 'block',
        filter: 'blur(5px)'

    },
    previewTextPremiumHalfBlurred: {
        '-webkit-user-select': 'none',
        '-khtml-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        '-o-user-select': 'none',
        userSelect: 'none',
        display: 'block',
        filter: 'blur(2px)'
    },
}));

interface Props {
    showDialog:boolean;
    freeAsset: boolean;
    isDisabled: boolean;
    currentPremiumAsset: PremiumSermonSeriesAsset | PremiumSermonAsset;
    onClose: () => void;
    activatePremiumContent: () => void;
    upSellSeries: () => void;
}

export function PreviewPremiumContentDialog(props:Props){
    const { showDialog, currentPremiumAsset, freeAsset, isDisabled} = props;
    const user = useAuthenticatedUser();
    const isMobile = useIsMobile();
    const classes = useStyles();

    return (
        <Dialog fullWidth maxWidth="md" fullScreen={isMobile} open={showDialog} onClose={() => props.onClose()} >
            <DialogTitle>
                <IconButton aria-label="Close" className={classes.previewCloseIcon} onClick={() => props.onClose()}>
                    <CloseIcon />
                </IconButton>
                <Typography variant="h5">{currentPremiumAsset.name}</Typography>
                <DialogActions style={{ width: "100%" }}>
                    {(user.makerSubscription || freeAsset ) ?
                        <Button color="primary" disabled={isDisabled} className={classes.userTemplateButton} size="large" onClick={props.activatePremiumContent} variant="contained">
                            Add to My Library
                        </Button>
                        :
                        <Button color="primary" disabled={isDisabled} className={classes.userTemplateButton} size="large" onClick={props.upSellSeries} variant="contained">
                            Unlock
                        </Button>
                    }
                </DialogActions>
            </DialogTitle>
            <Divider />
                <DialogContent>
                    {(user.makerSubscription || freeAsset) ?
                        <span className={classes.previewText} dangerouslySetInnerHTML={{ __html: currentPremiumAsset.builderAssetText }} />
                        :
                        <>
                        <span className={classes.previewText} dangerouslySetInnerHTML={{ __html: currentPremiumAsset.builderAssetText.substr(0, 500) }} />
                        <span className={classes.previewTextPremiumHalfBlurred} dangerouslySetInnerHTML={{ __html: currentPremiumAsset.builderAssetText.substr(500, 1000) }} />
                        <span className={classes.previewTextPremiumBlurred} dangerouslySetInnerHTML={{ __html: currentPremiumAsset.builderAssetText.substr(1000, 1500) }} />
                        <Typography variant="h6" component="h6" align="center" >Want to see everything? Unlock today!</Typography>
                        <Button color="primary" disabled={isDisabled} className={classes.userTemplateButton} size="large" onClick={props.upSellSeries} variant="contained">
                            Unlock
                        </Button>
                        </>
                    }
            </DialogContent>
        </Dialog>
    )
}